import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import Config from "../business/config.json";
import MapStyle from "./MapStyleComponent";

const GOOGLE_MAPS_JS_API_KEY = Config.googlemaps_api_key;

function MapComponent(props) {
  const [currentMarker, setCurrentMarker] = useState(0);
  const [map, setMap] = useState(null);
  const [zoom, setZoom] = useState(16);
  const [center, setCenter] = useState({
    lat: -35.2396526,
    lng: 149.0846053,
  });
  const [containerStyle] = useState({
    width: "100%",
    height: "600px",
    position: "relative",
  });
  const onLoad = React.useCallback(
    function callback(map) {
      if (undefined === map || map === null) return;
      const styledMap = new window.google.maps.StyledMapType(MapStyle);
      map.set("disableDefaultUI", true);
      map.mapTypes.set("styled_map", styledMap);
      map.setMapTypeId("satellite");
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          const coords = pos.coords;
          const currentCenter = {
            lat: coords.latitude,
            lng: coords.longitude,
          };
          setCenter(currentCenter);
          map.setCenter(currentCenter);
        });
      } else {
        map.setCenter(center);
      }
      setMap(map);
    },
    [center]
  );

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_JS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        {...props}
      >
        {props.children}
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(MapComponent);
